module.exports = __webpack_public_path__ + "static/media/customer-track-order.217b05bc.png";